<template>
    <v-layout row>
        <v-flex xs12>
            <v-container grid-list-xl fluid>
                <v-layout row wrap>
                    <router-view :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig" :existingData="{}"></router-view>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    name: 'DataOpsImportSetup',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
